module.exports = __webpack_public_path__ + "static/media/comment-filled-icon.73a8929e.svg";